import { Button, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useStyles } from './styles'

export const ButtonExecution = ({ children, id, counter, cleanFilter, getExecutionDetalData, queryv2, lastVersionId, getVersionQuestionaire, applyQuestionFilter, onChange, resetQuestionFilter }: { children: any, id: any, counter: number | null, cleanFilter: () => void, getExecutionDetalData: (idversion: string, query?: string) => Promise<void>, queryv2: string, lastVersionId: string, getVersionQuestionaire:(query?:string) => Promise<void>, applyQuestionFilter?: () => void, onChange?: (e: any) => void, resetQuestionFilter?: () => void }) => {
  const styles = useStyles()
  const { t } = useTranslation()

  const handleApply = () => {
    if (applyQuestionFilter) {
      applyQuestionFilter()
    }
    getVersionQuestionaire(queryv2)
  }

  const handleIconClick = () => {
    cleanFilter(); 
    if (onChange) {
      onChange({ target: { name: 'questions', value: [] } })
    }
    if (resetQuestionFilter) {
      resetQuestionFilter()
    }
    getVersionQuestionaire()
  };

  const isEmptyChildren = children?.type === 'div' && !children?.props?.children;

  return (
    <Grid container key={id}>
      {!isEmptyChildren && (
        <Grid item xs={12} sm={12} md={8} lg={8} xl={8} sx={styles.children}>{children}</Grid>
      )}
      <Grid item xs={12} sm={12} md={isEmptyChildren ? 12 : 4} lg={isEmptyChildren ? 12 : 4} xl={isEmptyChildren ? 12 : 4} sx={styles.main}>
        <Button onClick={handleApply} variant="contained" sx={styles.aplly}>{t('Questionarie.apply')}</Button>

        {!!counter && <Button sx={styles.btn} variant='text_primary' onClick={() => { handleIconClick() }}>{t('general.cleanFilters')}</Button>}
      </Grid>
    </Grid>
  )
}